import React from 'react'
import './Turnos.css'
import Turnos from '../Image/Aside/Turnos.png'

export const Turnoswa = () => {
    return (
        <>
            <a href="https://wa.me/3513908626">
                <img className='turnos' src={Turnos} alt="Enlace a Whatsapp" />
            </a>
        </>
    )
}

export default Turnoswa 